function cart_item_added()
{
 
  //execute scripts when item added to cart
  //fbq('track', 'AddToCart');

  return true;
}

function checkout_submit()
{
  //execute scripts when checkout process begins
  //fbq('track', 'InitiateCheckout');
  
  return true;
}

function subscribe_go(form)
{
  var input_valid = true;
  $(".input-error").removeClass("input-error");
  $(form).find(".required").each(function() {    
    var this_val = jQuery.trim($(this).val());
    $(this).val(this_val);
    if(this_val == "")
    {
      $(this).addClass("input-error");      
      input_valid = false;
    }
    else if ($(this).attr("type") == "email" && !validateEmail(this_val))
    {
      $(this).addClass("input-error");      
      input_valid = false;
    }
  });
  
  if(input_valid)
  {
    return false;
    $(form).find(".btn").attr('data-txt', $(form).find(".btn").val()).prop('disabled',true).val($(form).find(".btn").attr('data-loading-text'));

    $.ajax({
      type: "POST",
      url: $(form).attr('action'),
      data: $(form).serialize() + "&ajax=1",
      success: function(resp)
      {
        $(form).find(".btn").prop('disabled',false).val($(form).find(".btn").attr('data-txt'));
        if(resp.success)
        {
          $(form).find(".subscribe-entry").hide();
          $(form).find(".subscribe-done").show();
        }
        else
          subscribe_error();
      },
      error: function(resp)
      {
        $(form).find(".btn").prop('disabled',false).val($(form).find(".btn").attr('data-txt'));
        subscribe_error();
      },
      dataType: "json"
    });
  }
  
  return false;
}

function validateEmail(email)
{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function subscribe_error()
{
  alert("Oh no! We experienced an error with your subscription. Please try again.");
}

$(document).ready(function(){
  
//   $('.accordion-toggle').on({ 'touchstart' : function(){ 
   
//     var content = $(".accordion-content");
//       var toggle = $(".accordion-toggle");
//       var theclick = $(this);
    
//       content.slideUp('fast');
//       toggle.removeClass('open');
//       theclick.next().slideToggle('fast');
//       theclick.toggleClass('open');
  
//   } });
      	
  $('.accordion-toggle').on('click', function(){
      
      var content = $(".accordion-content");
      var toggle = $(".accordion-toggle");
      var theclick = $(this);
    	
      if( theclick.hasClass('open') ){
      	content.slideUp('fast');
        theclick.toggleClass('open');
      }
      else{
        content.slideUp('fast');
        toggle.removeClass('open');
        theclick.next().slideToggle('fast');
        theclick.toggleClass('open');
      }
    
  });
  
  // new overlay added when flyouts are active
  
  function addOverlay(){
  	setTimeout(function(){
  		$('.overlay-block').fadeIn();
  	},500);
  }
  
  $('.overlay-block').on('click', function(){
  	$(this).fadeOut();
  });
  
  $('.js-drawer-close').on('click', function(){
  	$('.overlay-block').fadeOut();
  });
  
  $('.site-nav--mobile button').on('click', function(){
  	$('.overlay-block').fadeIn();
  });
  
  $('.js-drawer-open-right').on('click', function(){
  	$('.overlay-block').fadeIn();
  });
  
  $('.js-drawer-open-right').on('click', function(){
  	$('.overlay-block').fadeIn();
  });  
  
  $('button#AddToCart').on('click', function(){
    addOverlay();
  });
  
  //$('.js-drawer-close').click();
  
  
  
});